import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";

@Component({
  selector: "app-date-wise-dispense",
  templateUrl: "./date-wise-dispense.component.html",
  styleUrls: ["./date-wise-dispense.component.css"],
})
export class DateWiseDispenseComponent implements OnInit {
  dispenseArray: any = [];
  dispenseArrayList: any = [];
  month: any;
  myArr: any = [];
  paramId: any;
  paramCompany: any;
  paramSupervisor: any;
  userSessionData: any = JSON.parse(sessionStorage.getItem("userSession"));
  monthName: String;
  monthArrFull: any = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  monthArr: Array<String> = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  year: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.month = Number(param.id); // 1–12
      this.paramCompany = param.company;
      this.paramSupervisor = param.supervisor;
      this.monthName = this.monthArr[this.month - 1]; 
      this.year = Number(param.year);
    });
  }

  ngOnInit(): void {
    this.getDispense();
  }
  getDispense() {
    this.spinner.show();

    this.superAdminService
      .getDateWiseCashDispense(this.year, this.month, this.paramSupervisor)
      .subscribe({
        next: (res: any) => {
          if (!res.status) {
            this.toastr.error(res.message);
            this.spinner.hide();
            return;
          }

          let data = res.data || [];
          const role = this.userSessionData.user_role_id[0];

          // Role-based filtering (optional, backend preferred)
          if (role !== 1 && role !== 7) {
            data = data.filter(
              (item: any) => item.supervisorId === this.userSessionData._id
            );
          }

          // Company filter (since route contains companyId)
          this.dispenseArrayList = data.filter(
            (item: any) => item.companyId === this.paramCompany
          );

          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error("Failed to load date-wise dispense");
        },
      });
  }

  backTo() {
    window.history.back();
  }
}
